import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useCart } from 'Checkout/Hooks/useCart'
import { routesHandler } from 'Checkout/Routes/routesHandler'
import { useValidateReservations } from 'Checkout/Hooks/useValidateReservations'
import { formatDate } from 'Utils/Dates'
import CartDetails from 'Checkout/Components/Cart/CartDetails'
import Header from 'Checkout/Components/Shared/Header/Header'
import MainColumn from 'Checkout/Components/Shared/MainColumn/MainColumn'
import ReservationDetails from 'Checkout/Components/Shared/ReservationDetails/ReservationDetails'
import Section from 'Checkout/Components/Shared/Section/Section'
import SideColumn from 'Checkout/Components/Shared/SideColumn/SideColumn'

const Cart = () => {
  const { push } = useHistory()
  const { fillCurrentReservationFromCart } = useCart()
  const validateReservations = useValidateReservations()
  const reservations = useSelector(state => state.cart.reservations)
  const { isGroupBookingAvailable, slug } = useSelector(state => state.campground)
  const rate = useSelector(state => state.search.rate)
  const { accommodation, checkIn, checkOut, siteType } = useSelector(state => state.search)

  const goToSearch = () => {
    const checkInFormatted = formatDate(checkIn)
    const checkOutFormatted = formatDate(checkOut)
    const { type } = siteType
    const datesParams = `check_in=${checkInFormatted}&check_out=${checkOutFormatted}`
    const url = `/search?accommodation=${accommodation}&${datesParams}&site_type=${type}`
    push(url)
  }

  useEffect(() => {
    if (slug && !reservations.length) {
      if (rate) return push(routesHandler.details.path)
      if (siteType?.type) return goToSearch()

      return push(routesHandler.home.path)
    }
  }, [slug, reservations.length])

  useEffect(() => {
    if (!isGroupBookingAvailable && reservations.length)
      fillCurrentReservationFromCart(reservations[0].nanoId, { withRedirectTo: 'search' })
  }, [])

  useEffect(() => {
    validateReservations()
  }, [reservations])

  return (
    <Section name="cart">
      <MainColumn lg="7" xl="8">
        <Header hr={false} />

        <CartDetails />
      </MainColumn>

      <SideColumn showOnMobile lg="5" xl="4">
        <ReservationDetails />
      </SideColumn>
    </Section>
  )
}

export default Cart
